export default "__VITE_ASSET__qfEwEcDH__"